define.alias("shared/components/shared/social/basic-display-deprecation/wizard", "preview-grid/components/shared/social/basic-display-deprecation/wizard");